// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    VIDEO_AREA_CONTAINER: 'video_area_container',
    VIDEO_AREA_SCRIPT: 'video_area_script',
};

export const defaultAttributes = {
    VIDEO_AREA_IFRAME: 'cdm-video-area-iframe',
    VIDEO_AREA_PARAMS: 'enablejsapi=1',
    VIDEO_AUTO_PLAY: 'autoplay=1',
    VIDEO_AUTO_ALLOW_ATTRIBUTES:
        'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
    VIDEO_THUMBNAIL_QUALITY: 'maxresdefault',
};